// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-accessories-popup .main-container {
  height: 100%;
  display: flex;
  justify-content: center;
  margin-left: 20px;
  font-family: Roboto;
}
app-accessories-popup .main-container .popup-container {
  width: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
}
app-accessories-popup .main-container .popup-container > .popup {
  position: relative;
  flex-flow: column;
  display: flex;
  position: relative;
  height: 80%;
  border-radius: 20px;
}
app-accessories-popup .main-container .popup-container > .popup > .close {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: rgba(211, 216, 0, 0.7);
  border-radius: 50%;
  box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);
  color: #fff;
  top: -36px;
  right: -36px;
  cursor: pointer;
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner {
  flex-flow: column;
  display: flex;
  border-radius: 20px;
  border: 3px solid #D3D800;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.2);
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner > .tabs {
  display: flex;
  font-weight: 500;
  font-size: 18px;
  color: #fff;
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner > .tabs > .tab {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 57px;
  background: rgba(255, 255, 255, 0.2);
  cursor: pointer;
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner > .tabs > .tab.active {
  background: rgba(211, 216, 0, 0.8);
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner > .items-container {
  display: flex;
  height: 100%;
  overflow: auto;
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner > .items-container > .items {
  flex: 1;
  padding: 10px;
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner > .items-container > .items.accessories {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner > .items-container > .items.accessories app-accessory-thumbnail {
  width: 100px;
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner > .items-container > .items.universes {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner > .items-container > .items.universes app-accessory-thumbnail {
  width: 300px;
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner > .items-container > .items > .item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner > .items-container > .items > .item > img {
  border-radius: 5px;
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner .buttons {
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner .buttons .button {
  width: 50%;
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner .buttons .button .inner-button {
  border-radius: 100px;
  text-align: center;
  padding: 10px;
  margin-left: 10%;
  margin-right: 10%;
  font-weight: 500;
  color: #FFFFFF;
  background: rgba(151, 151, 151, 0.8);
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner .buttons .button .inner-button.enabled {
  cursor: pointer;
  background: rgba(211, 216, 0, 0.8);
}
app-accessories-popup .main-container .popup-container > .popup > .popup-inner .loading {
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.3);
}
app-accessories-popup .main-container .controls {
  display: flex;
  justify-content: center;
  align-self: flex-end;
}
app-accessories-popup .main-container .control {
  cursor: pointer;
}
app-accessories-popup .main-container .customize-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
app-accessories-popup .main-container .customize-container .customize {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 58px;
  height: 58px;
  background: rgba(211, 216, 0, 0.7);
  border-radius: 50%;
  box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);
  color: #fff;
}
app-accessories-popup .main-container .customize-container .customize path {
  fill: #ffffff !important;
}
app-accessories-popup .ps__rail-y {
  opacity: 1;
  display: block;
  width: 12px;
}
app-accessories-popup .ps__rail-y .ps__thumb-y {
  width: 12px;
  background-color: rgba(211, 216, 0, 0.8);
  opacity: 1;
}
app-accessories-popup .ps__rail-y:hover .ps__thumb-y {
  background-color: rgba(211, 216, 0, 0.8);
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/@modules/gamification/core/accessories-popup/accessories-popup.component.scss"],"names":[],"mappings":"AACI;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;AAAR;AAEQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAAZ;AAEY;EACI,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AAAhB;AAEgB;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,iDAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AAApB;AAGgB;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,oCAAA;AADpB;AAGoB;EACI,aAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AADxB;AAGwB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;AAD5B;AAG4B;EACI,kCAAA;AADhC;AAMoB;EACI,aAAA;EACA,YAAA;EACA,cAAA;AAJxB;AAMwB;EACI,OAAA;EACA,aAAA;AAJ5B;AAM4B;EACI,aAAA;EACA,qCAAA;AAJhC;AAMgC;EACI,YAAA;AAJpC;AAQ4B;EACI,aAAA;EACA,qCAAA;AANhC;AAQgC;EACI,YAAA;AANpC;AAU4B;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AARhC;AAUgC;EACI,kBAAA;AARpC;AAcoB;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EAEA,gBAAA;EACA,eAAA;EACA,yBAAA;AAbxB;AAewB;EACI,UAAA;AAb5B;AAe4B;EACI,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;AAbhC;AAegC;EACI,eAAA;EACA,kCAAA;AAbpC;AAqBoB;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;AAnBxB;AAyBQ;EACI,aAAA;EACA,uBAAA;EACA,oBAAA;AAvBZ;AA0BQ;EACI,eAAA;AAxBZ;AA4BQ;EACI,OAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;AA1BZ;AA4BY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,iDAAA;EACA,WAAA;AA1BhB;AA4BgB;EACI,wBAAA;AA1BpB;AAgCI;EACI,UAAA;EACA,cAAA;EACA,WAAA;AA9BR;AAgCQ;EACI,WAAA;EACA,wCAAA;EACA,UAAA;AA9BZ;AAkCY;EACI,wCAAA;EACA,UAAA;AAhChB","sourcesContent":["app-accessories-popup {\n    .main-container {\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        margin-left: 20px;\n        font-family: Roboto;\n\n        .popup-container {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            overflow: hidden;\n\n            >.popup {\n                position: relative;\n                flex-flow: column;\n                display: flex;\n                position: relative;\n                height: 80%;\n                border-radius: 20px;\n\n                >.close {\n                    position: absolute;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    width: 40px;\n                    height: 40px;\n                    background: rgba(211, 216, 0, 0.7);\n                    border-radius: 50%;\n                    box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);\n                    color: #fff;\n                    top: -36px;\n                    right: -36px;\n                    cursor: pointer;\n                }\n\n                >.popup-inner {\n                    flex-flow: column;\n                    display: flex;\n                    border-radius: 20px;\n                    border: 3px solid #D3D800;\n                    overflow: hidden;\n                    background: rgba(255, 255, 255, 0.2);\n\n                    >.tabs {\n                        display: flex;\n                        font-weight: 500;\n                        font-size: 18px;\n                        color: #fff;\n\n                        >.tab {\n                            display: flex;\n                            align-items: center;\n                            justify-content: center;\n                            width: 50%;\n                            height: 57px;\n                            background: rgba(255, 255, 255, 0.2);\n                            cursor: pointer;\n\n                            &.active {\n                                background: rgba(211, 216, 0, 0.8);\n                            }\n                        }\n                    }\n\n                    >.items-container {\n                        display: flex;\n                        height: 100%;\n                        overflow: auto;\n\n                        >.items {\n                            flex: 1;\n                            padding: 10px;\n\n                            &.accessories {\n                                display: grid;\n                                grid-template-columns: repeat(3, 1fr);\n\n                                app-accessory-thumbnail {\n                                    width: 100px;\n                                }\n                            }\n\n                            &.universes {\n                                display: grid;\n                                grid-template-columns: repeat(1, 1fr);\n\n                                app-accessory-thumbnail {\n                                    width: 300px;\n                                }\n                            }\n\n                            >.item {\n                                display: flex;\n                                justify-content: center;\n                                align-items: center;\n                                margin: 10px;\n\n                                >img {\n                                    border-radius: 5px;\n                                }\n                            }\n                        }\n                    }\n\n                    .buttons {\n                        z-index: 999;\n                        display: flex;\n                        justify-content: center;\n                        align-items: center;\n                        padding: 10px;\n\n                        font-weight: 500;\n                        font-size: 11px;\n                        text-transform: uppercase;\n\n                        .button {\n                            width: 50%;\n\n                            .inner-button {\n                                border-radius: 100px;\n                                text-align: center;\n                                padding: 10px;\n                                margin-left: 10%;\n                                margin-right: 10%;\n                                font-weight: 500;\n                                color: #FFFFFF;\n                                background: rgba(151, 151, 151, 0.8);\n\n                                &.enabled {\n                                    cursor: pointer;\n                                    background: rgba(211, 216, 0, 0.8);\n                                }\n\n                            }\n\n                        }\n                    }\n\n                    .loading {\n                        position: absolute;\n                        height: 100%;\n                        width: 100%;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        background: rgba(255, 255, 255, 0.3);\n                    }\n                }\n            }\n        }\n\n        .controls {\n            display: flex;\n            justify-content: center;\n            align-self: flex-end;\n        }\n\n        .control {\n            cursor: pointer;\n\n        }\n\n        .customize-container {\n            flex: 1;\n            display: flex;\n            justify-content: center;\n            align-items: flex-end;\n\n            .customize {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                width: 58px;\n                height: 58px;\n                background: rgba(211, 216, 0, 0.7);\n                border-radius: 50%;\n                box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);\n                color: #fff;\n\n                path {\n                    fill: #ffffff !important;\n                }\n            }\n        }\n    }\n\n    .ps__rail-y {\n        opacity: 1;\n        display: block;\n        width: 12px;\n\n        .ps__thumb-y {\n            width: 12px;\n            background-color: rgba(211, 216, 0, 0.8);\n            opacity: 1;\n        }\n\n        &:hover {\n            .ps__thumb-y {\n                background-color: rgba(211, 216, 0, 0.8);\n                opacity: 1;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
